import styled, { css } from 'styled-components';
import cssKit from '../../css';
import Button from '../../components/Button';

const nissan = process.env.BRAND_NAME === 'nissan';
const helios = process.env.VENDOR === 'helios';

export const StyledDealerListTitle = styled.span`
  font-family: ${cssKit.fonts.bold};
  font-size: 1.5rem;
  padding-bottom: 20px;
  width: 100%;
  border-bottom: 1px dotted #e1e1e1;
  display:inline-block;
`;

export const SearchSvgWrapperStyled = styled.span`
  display: inline-block;
  position: absolute;
  top: ${helios ? '0' : '-6px'};
  right: ${helios ? '0' : '-6px'};
  padding: .5rem .5rem .5rem .5rem;
  width: 3.35rem;

  button {
    width: 100%;
    padding: .35rem
  }
`;

export const StyledZipSearchByline = styled.span`
  font-family: ${cssKit.fonts.bold};
  font-size: .85rem;
  padding-bottom: .75rem;
  display: inline-block;
`;

const StyledButton = styled(Button) ``;

export const StyledZipSearchButton = styled.button`
  ${nissan && css`
    ${StyledButton} {
      padding: 1em 1em;
      background-color: #fff;
      color: #000;
      width: 40px;
      height: 40px;
    }
    &:after {
      font-family: ${cssKit.fonts.icon};
      content: ${helios ? '\\e670' : ''};
      padding:.25em .25em .25em .25em;
      font-size: 1.5rem;
      color: #c51a47;
    }
  `
  }
  ${!nissan && css`
    ${StyledButton} {
      padding: 1em 1em;
      background-color: #fff;
      color: #000;
      width: 40px;
      height: 40px;
    }
    &:after {
      font-family: ${cssKit.fonts.icon};
      content: ${helios ? '\\e607' : ''};
      padding:.25em .25em .25em .25em;
      font-size: 1.5rem;
      color: #000
  }
  `}
`;



/** WEBPACK FOOTER **
 ** ./src/components/DealersListZipSearchForm/styles.js
 **/